import React from "react";
import Template from "../../components/template/Template";
import MainBackground from "../../components/template/MainBackground";

import "./contacts.css";

function Contacts() {
  return (
    <Template>
      <MainBackground>
        <div className="contact-contenair">
          <div className="contact-main">
            <div className="contact-title">
              <h2>ÉTABLIR UN RENDEZ VOUS</h2>
            </div>
            <div className="contact-text">
              Vous pouvez me contacter par téléphone pour m'exposer vos besoins
              et conclure d'un rendez-vous :
              <div className="contact-number">
                <a href="tel:0621848857" style={{}}>
                  06 21 84 88 57
                </a>
              </div>
              <div className="contact-info">
                Si vous avez des questions d'ordre informatique (Quel anti-virus
                choisir ? À quelle fréquence faut-il changer sa pate thermique ?
                etc), vous pouvez me les adresser par mail à l'adresse suivante
                :
                <div className="contact-mail">
                  <a href="mailto:contact@reparation-informatique.fr">
                    contact@reparation-informatique.fr
                  </a>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </MainBackground>
      <div className="contact-filler"></div>
    </Template>
  );
}

export default Contacts;
